export class Dot {
    x: number;
    y: number;
    constructor(data) {
        this.x = data.x;
        this.y = data.y;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/stats/dot.ts